'use strict'
$(document).ready(function () {
  if ($('.search-field').length) {
    $('#filter').click(function () {
      if ($('.search-field').val().length === 0) {
        $('.search-field').addClass('red-placeholder')
        $('.search-field').attr('placeholder', 'Required')
      }
    })
    $('.search-form').submit(function (event) {
      event.preventDefault()
      if ($('.search-field').val().length === 0) {
        $('.search-field').addClass('red-placeholder')
        $('.search-field').attr('placeholder', 'Required')
      } else {
        $(this).off('submit')
        $(this).submit()
      }
    })
  }
})
// START PERHAPS TEMPORARY FOR DEV FOR OFFLINE DEVELOPMENT
// Importing jquery makes the build very slow
// import $ from 'jquery'
// END PERHAPS TEMPORARY FOR DEV FOR OFFLINE DEVELOPMENT

// Polyfills ////////////////////////////////////////////////////////
// Unsorted
// import 'babel-polyfill'

// Most browsers at this point

// Custom Modernizr build includes:
//  detect for position: sticky.
//  detect for CSS @supports.
import mdnzr from './modules/modernizr-custom.js'
mdnzr()

// 2016/01/19 Everyone but Chrome
import 'requestidlecallback' // Polyfill for requestidlecallback

// A bunch of browsers need this
import hyperform from 'hyperform'
$(document).ready(function () {
  hyperform(document.getElementsByClassName('searchexpandable')[0])
})

// IE 11 and below (All IE versions)
import 'classlist-polyfill' // MDN's ClassList polyfill

// IE 10 and below

// IE 9 and below
// import 'placekeeper' // CURRENTLY BREAKS SAFARI 10 HTML placeholders polyfill
import 'requestanimationframe' // Polyfill for requestanimationframe

// Responsive image libraries ///////////////////////////////////////
import 'lazysizes'

// Animation libraries //////////////////////////////////////////////
// import 'waypoints/lib/noframework.waypoints.js'
// import 'waypoints/lib/shortcuts/inview.min.js'
// import 'gsap/src/uncompressed/TweenLite'
// import 'gsap/src/uncompressed/plugins/CSSPlugin'
// import 'gsap/src/uncompressed/easing/EasePack'

// Vendor

import debounce from './modules/debounce.js'

// MintTwist code begin
import verticallyalignwithinparent from './modules/verticallyalignwithinparent.js'
if (!Modernizr.supports) {
  var alignLogos = debounce(function () {
        // All the taxing stuff you do
    verticallyalignwithinparent($('.rating-main-company-logo img'))
  }, 250)
  alignLogos()
  window.addEventListener('resize', alignLogos)
}

import skytraxcarousels from './modules/mt-skytraxcarousels.js'
skytraxcarousels()

import {addResponsiveVideoClasses} from './modules/mt-addResponsiveVideoClasses.js'
$(document).ready(function () {
  addResponsiveVideoClasses('.wysiwyg-content')
})

$(document).ready(function () {
  $('.wysiwyg-content p img, .wysiwyg-content p picture').closest('p').addClass('p-containsimage')
})

// Components //////////////////////////////////////////////
import siteheader from '../components/siteheader/siteheader.js'
siteheader()

import sitenavbar from '../components/sitenavbar/sitenavbar.js'
sitenavbar()

import accordion from '../components/accordion/accordion.js'
accordion()

import tabs from '../components/tabs/tabs.js'
$(document).ready(function () {
  tabs()
})

import questionanswer from '../components/questionanswer/questionanswer.js'
questionanswer()

import worldmap from '../components/worldmap/worldmap.js'
worldmap()

import breadcrumbs from '../components/breadcrumbs/breadcrumbs.js'
breadcrumbs()

import grid from '../components/grid/grid.js'
grid()

import quicklocationselectsearch from '../components/quicklocationselectsearch/quicklocationselectsearch.js'
quicklocationselectsearch()

import smoothinternal from './modules/smoothscrollallinternallinks.js'
smoothinternal()

// IE11 flexbox fixes
import equalheightgridrows from './modules/equalheightgridrows.js'

// Equal height rows for the superportal in IE9 where the carousel (FlickityV2) isn't supported so we've made it a grid.
$(document).ready(function () {
  if ($('html').hasClass('lt-ie10')) {
    equalheightgridrows('.super-carousel .carousel-cell')
    $(window).load(function () {
      equalheightgridrows('.super-carousel .carousel-cell')
    })
  }
})

import refreshlazyads from './modules/lazyloadadvertisements.js'
$(document).ready(function () {
  setTimeout(refreshlazyads, 1000)
})

// Truncate an element to a specified height if the element is of certain proportions. Animate back to full height on the click of a 'read more' button.
// $(document).ready(function () {
//   if ($('.mobile-truncate').length) {
//     $('.mobile-truncate').each(function () {
//       const elem = $(this)
//       if (elem.height() / elem.width() > 1.1) {
//         const truncHeight = 180
//         elem.css({'height': truncHeight})
//         elem.addClass('mobile-truncate--yes mobile-truncate--closed')
//         let rmbutton = $('<button class="mobile-truncate__button">Read more <i class="fa fa-chevron-down"></i></button>')
//         elem.append(rmbutton)
//         rmbutton.click(function () {
//           var el = elem,
//             curHeight = truncHeight,
//             autoHeight = el.css('height', 'auto').height()
//           el.height(curHeight)
//           setTimeout(function () {
//             el.css({transition: 'height 1000ms', height: autoHeight})
//           }, 10)
//           rmbutton.fadeOut(function () {
//             rmbutton.remove()
//             elem.removeClass('mobile-truncate--closed')
//           })
//         })
//       }
//     })
//   }
// })

// Hide the n+3 children of an element and reveal on a 'Read more' button click.
$(document).ready(function () {
  if ($('.mobile-truncate').length) {
    $('.mobile-truncate').each(function () {
      const elem = $(this),
        elemsToTruncate = elem.children().not(':nth-child(-n+2)')

      if (elem.height() / elem.width() > 1.0) {
        elemsToTruncate.hide()
        elem.addClass('mobile-truncate--yes mobile-truncate--closed')
        let rmbutton = $('<button class="mobile-truncate__button">Read more <i class="fa fa-chevron-down"></i></button>')
        elem.append(rmbutton)
        elem.css({'padding-bottom': rmbutton.outerHeight()})

        rmbutton.click(function () {
          elemsToTruncate.slideDown('fast')
          rmbutton.fadeOut(function () {
            rmbutton.remove()
            elem.removeClass('mobile-truncate--closed')
          })
        })
      }
    })
  }
})

// The following is a Vanilla Javascript Browser Cookies API
$(document).ready(function () {
  ;
  (function (factory) {
    var registeredInModuleLoader = false
    if (typeof define === 'function' && define.amd) {
      define(factory)
      registeredInModuleLoader = true
    }
    if (typeof exports === 'object') {
      module.exports = factory()
      registeredInModuleLoader = true
    }
    if (!registeredInModuleLoader) {
      var OldCookies = window.Cookies
      var api = window.Cookies = factory()
      api.noConflict = function () { window.Cookies = OldCookies; return api }
    }
  }(function () {
    function extend () { var i = 0; var result = {}; for (; i < arguments.length; i += 1) { var attributes = arguments[i]; for (var key in attributes) { result[key] = attributes[key] } } return result }

    function init (converter) {
      function api (key, value, attributes) {
        var result
        if (typeof document === 'undefined') { return }
        if (arguments.length > 1) {
          attributes = extend({ path: '/' }, api.defaults, attributes)
          if (typeof attributes.expires === 'number') {
            var expires = new Date()
            expires.setMilliseconds(expires.getMilliseconds() + attributes.expires * 864e+5)
            attributes.expires = expires
          }
          attributes.expires = attributes.expires ? attributes.expires.toUTCString() : ''
          try { result = JSON.stringify(value); if (/^[\{\[]/.test(result)) { value = result } } catch (e) {}
          if (!converter.write) { value = encodeURIComponent(String(value)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent) } else { value = converter.write(value, key) }
          key = encodeURIComponent(String(key))
          key = key.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
          key = key.replace(/[\(\)]/g, escape)
          var stringifiedAttributes = ''
          for (var attributeName in attributes) {
            if (!attributes[attributeName]) { continue }
            stringifiedAttributes += '; ' + attributeName
            if (attributes[attributeName] === true) { continue }
            stringifiedAttributes += '=' + attributes[attributeName]
          }
          return (document.cookie = key + '=' + value + stringifiedAttributes)
        }
        if (!key) { result = {} }
        var cookies = document.cookie ? document.cookie.split('; ') : []
        var rdecode = /(%[0-9A-Z]{2})+/g
        var i = 0
        for (; i < cookies.length; i += 1) {
          var parts = cookies[i].split('=')
          var cookie = parts.slice(1).join('=')
          if (cookie.charAt(0) === '"') { cookie = cookie.slice(1, -1) }
          try {
            var name = parts[0].replace(rdecode, decodeURIComponent)
            cookie = converter.read ? converter.read(cookie, name) : converter(cookie, name) || cookie.replace(rdecode, decodeURIComponent)
            if (this.json) { try { cookie = JSON.parse(cookie) } catch (e) {} }
            if (key === name) { result = cookie; break }
            if (!key) { result[name] = cookie }
          } catch (e) {}
        }
        return result
      }
      api.set = api
      api.get = function (key) { return api.call(api, key) }
      api.getJSON = function () { return api.apply({ json: true }, [].slice.call(arguments)) }
      api.defaults = {}
      api.remove = function (key, attributes) { api(key, '', extend(attributes, { expires: -1 })) }
      api.withConverter = init
      return api
    }
    return init(function () {})
  }));

  // The following code for the Cookie notice. (above should be the code for the API used in the code below)
  (function () {
    if (!Cookies.get('mtcookie')) {
      var mtcookie = document.getElementById('mtcookie')

      function mtcookieshoo () {
        mtcookie.style.opacity = '0'
        window.setTimeout(function () {
                    // mtcookie.style.display = 'none'
          $(mtcookie).removeClass('mtcookie--visible')
        }, 1000)
      }

      function mtcookieyo () {
                // mtcookie.style.display = 'block'
        $(mtcookie).addClass('mtcookie--visible')
        window.setTimeout(function () {
          mtcookie.style.opacity = '1'
        }, 1000)
      }
      mtcookieyo()
      Cookies.set('mtcookie', true)
      mtcookie.onclick = mtcookieshoo
    }
  })()
})
